import { module as BaseModule } from "modujs"
import { createApp } from 'vue'
import ProjectList from '../components/ProjectList.vue'

export default class extends BaseModule {
  constructor(m) {
    super(m)
    
    if (!appData || !appData.projectEntries) {
      return
    }

    this.projectEntries = appData.projectEntries
    this.mountPoint = this.el.querySelector('#project-list-mount')
  }
  

  init() {
    if (!this.mountPoint || !this.projectEntries) {
      return
    }

    // Get sort icon URL - try to get from data attribute or use default path
    const sortIconUrl = this.el.getAttribute('data-sort-icon-url') || 
      `${window.location.origin}/app/wp-content/themes/bel-architecten-theme/public/images/sort.svg`

    // Create Vue app
    this.app = createApp(ProjectList, {
      projects: this.projectEntries,
      sortIconUrl: sortIconUrl,
    })

    this.app.mount(this.mountPoint)
  }

  destroy() {
    if (this.app) {
      this.app.unmount()
    }
  }
}
